import React from 'react';

export const HeadMiClub = () => {
	return (
		<div className='headContentUsuarios head-for-documentos'>
			<div className='superiorHeadContentUsuarios'>
				<div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="20" x2="12" y2="10"></line><line x1="18" y1="20" x2="18" y2="4"></line><line x1="6" y1="20" x2="6" y2="16"></line></svg>
				</div>
				<div className='centrador titleHeadHistorialFacturas'>
					<b>Mi Club</b>
				</div>
			</div>
		</div>
	);
};